// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1XGp8","content":"Consent_content__1ktop","footer":"Consent_footer__Er6Fu"};